/**
 * Created by Ning Jiang on 2021-06-10.
 */

import {WinPresentationController} from "../WinPresentationController";
import {gsap, TimelineLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {DeadwoodRip} from "../../DeadwoodRip";
import {DeadwoodRipBackground} from "../../view/DeadwoodRipBackground";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";

export class XSplitController extends WinPresentationController {

    private _xSplitPosition:number[][] = [
        [1],
        [1, 2],
        [1, 2],
        [1, 2],
        [0]
    ];
    private _symbolDelay:number = 1.2
    private _splitAnimationDelay:number = 0.1
    private _animations:TimelineLite[] = [];

    constructor() {
        super("xSplitController", true);
    }

    protected hasWin():boolean {
        return DeadwoodRip.model.parsedGameData.doXSplit;
    }

    protected async createWinAnimation():Promise<void> {
        DeadwoodRip.playScattersWin = true;
        const promises:Promise<any>[] = [];
        const noWin:boolean = DeadwoodRip.model.parsedGameData.singleWin === 0;
        let symbolSplitDelay = 100;
        this._xSplitPosition.forEach((reelPositions, reelId) => {
            const isNudgeReel = DeadwoodRip.model.parsedGameData.nudgeSteps[reelId] > 0 || DeadwoodRip.model.parsedGameData.evaluatedArea[reelId][0] === "WXN";
            reelPositions.forEach((symId, index) => {
                if(isNudgeReel && index > 0) {
                    return;
                }
                const tl = new TimelineLite();
                const symbol = DeadwoodRip.reels[reelId].getSymbol(symId);
                tl.add(symbol.split(1, noWin), noWin ? 0 : (symbol.symbolName.includes("S2") ? 0 : this._symbolDelay));
                symbolSplitDelay = Math.min(symbolSplitDelay, symbol.splitSplashDelay);
                tl.add(() => ArrayHelper.removeFirstMatchElement(this._animations, tl));
                this._animations.push(tl);
                promises.push(Promise.resolve(tl));
            });
        });

        const totalTl = new TimelineLite();
        if(noWin) {
            totalTl.add(() => {
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.SYMBOL_SPLIT});
            }, symbolSplitDelay);
        } else {
            // totalTl.add(() => {
            //     DeadwoodRipBackground.shakeStageOnce(0.5);
            // }, this._splitAnimationDelay);
            totalTl.add(() => {
                const shakeTl = new TimelineLite({paused : true});
                shakeTl.add(gsap.to(DeadwoodRipBackground.stage, {x : 16, y : -8, duration : 0.033}));
                shakeTl.add(gsap.to(DeadwoodRipBackground.stage, {x : 0, y : 0, duration : 0.267}));
                shakeTl.add(gsap.to(DeadwoodRipBackground.stage, {x : 12, y : -6, duration : 0.033}));
                shakeTl.add(gsap.to(DeadwoodRipBackground.stage, {x : 0, y : 0, duration : 0.133}));
                shakeTl.add(gsap.to(DeadwoodRipBackground.stage, {x : 8, y : -4, duration : 0.033}));
                shakeTl.add(gsap.to(DeadwoodRipBackground.stage, {x : 0, y : 0, duration : 0.133}));
                DeadwoodRipBackground.moveStage(shakeTl);
            }, this._splitAnimationDelay);

            // sound
            totalTl.add(() => {
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.AXE_APPEAR});
            }, this._symbolDelay);
            totalTl.add(() => {
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.AXE_HIT});
            }, this._splitAnimationDelay + this._symbolDelay);
            totalTl.add(() => {
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.SYMBOL_SPLIT});
            }, symbolSplitDelay + this._symbolDelay);

            promises.push(Promise.resolve(totalTl));
        }

        await Promise.all(promises);
        await DeadwoodRip.ways.xSplit();
    }

    public skip():void {
        this._animations.forEach(animation => {
            animation.timeScale(2);
        });
    }
}